import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

interface TypingIndicatorProps {
  userName: string;
}

// Dot animation
const bounce = keyframes`
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.5;
  }
  40% {
    transform: translateY(-8px);
    opacity: 1;
  }
`;

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ userName }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        mb: 1
      }}
    >
      <Box sx={{ maxWidth: '70%' }}>
        <Typography variant="caption" color="text.secondary" sx={{ ml: 1, mb: 0.5, fontSize: '1.125rem' }}>
          {userName} is typing...
        </Typography>
        <Paper
          elevation={1}
          sx={{
            p: 1.5,
            px: 2,
            bgcolor: 'white',
            borderRadius: 2,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5
          }}
        >
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: 'grey.400',
                animation: `${bounce} 1.4s infinite ease-in-out both`,
                animationDelay: `${index * 0.16}s`
              }}
            />
          ))}
        </Paper>
      </Box>
    </Box>
  );
};

export default TypingIndicator;

